<template>
    <div class="rputersAdd">
        <Head-view :showStyle="3"></Head-view>
        <div class="main">
            <div class="breadcrumb" @click="backClose">
                路线管理 &nbsp;/&nbsp;
                <span style="color: rgba(132, 133, 135, 1)">{{
                    editTitle
                }}</span>
            </div>
            <div class="breadcrumbChilder">{{ editTitle }}</div>
            <div class="showTba">
                <div class="addBox">
                    <div class="instMsg">路线信息</div>
                    <div class="commRowstyle logo">
                        <div class="inpTitle logoSplick">路线图片</div>
                        <div
                            class="addHeadImg"
                            :class="[!imgHead ? 'borderClass' : '']"
                        >
                            <input
                                type="file"
                                name="file"
                                ref="headImgRef"
                                accept="image/*,.jpg,.png,.git,.webp,.svg,"
                                @change="uploadHeadImg()"
                                v-if="!imgHead && !msgFlag"
                            />
                            <img :src="imgHead" v-if="imgHead" alt="" />
                            <div
                                class="delHeadImg"
                                v-if="imgHead && !msgFlag"
                                @click="delHeadImg()"
                            >
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span>路线名称</div>
                        <div class="inpFrom">
                            <el-input
                                v-model="routeName"
                                placeholder="请输入"
                                @blur="trimBoth('name', routeName)"
                                :disabled="msgFlag"
                            ></el-input>
                        </div>
                    </div>
                    <div class="requirementBody marginTop_30">
                        <div class="left">
                            <div class="requirementTop">
                                <div class="requirementTitle">点位列表</div>
                                <div
                                    class="requirementAddBtn"
                                    @click="addPlace()"
                                    v-if="!msgFlag"
                                >
                                    添加点位
                                </div>
                            </div>
                            <div class="requirementTab">
                                <el-table
                                    :data="tableData"
                                    stripe
                                    style="width: 1002px"
                                    height="350"
                                    :cell-style="{ 'text-align': 'center' }"
                                    :header-cell-style="{
                                        backgroundColor:
                                            'rgba(246, 245, 245, 1)',
                                        height: '56px',
                                        'text-align': 'center',
                                    }"
                                    v-loading="loading"
                                >
                                    <el-table-column label="顺序" width="150">
                                        <template slot-scope="scope">
                                            <div class="colorBlur">
                                                {{ scope.$index + 1 }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="点位图片"
                                        width="180"
                                    >
                                        <template slot-scope="scope">
                                            <div class="routerImg">
                                                <img
                                                    v-if="scope.row.picture"
                                                    :src="scope.row.picture"
                                                    alt=""
                                                />
                                                <img v-if="!scope.row.picture" src="../../../assets/placeDefaultImg.png" alt="" />
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="name"
                                        label="点位名称"
                                        width="150"
                                    >
                                    </el-table-column>

                                    <el-table-column
                                        prop="LongAndLati"
                                        label="经纬度"
                                        width="290"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        fixed="right"
                                        label="操作"
                                        width="230"
                                        v-if="!msgFlag"
                                    >
                                        <template slot-scope="scope">
                                            <el-button
                                                @click="
                                                    handleUpMove(
                                                        scope.$index,
                                                        scope.row
                                                    )
                                                "
                                                class="moveBtn"
                                                type="success"
                                                size="small"
                                                v-if="!(scope.row.index == 1)"
                                                >上移</el-button
                                            >
                                            <el-button
                                                @click="
                                                    handleDownMove(
                                                        scope.$index,
                                                        scope.row
                                                    )
                                                "
                                                class="moveBtn"
                                                type="success"
                                                size="small"
                                                v-if="
                                                    !(
                                                        tableDataLength ==
                                                        scope.row.index
                                                    )
                                                "
                                                >下移</el-button
                                            >
                                            <el-button
                                                size="mini"
                                                type="danger"
                                                @click="
                                                    handleDelete(
                                                        scope.$index,
                                                        scope.row
                                                    )
                                                "
                                                >删除</el-button
                                            >
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="right">
                            <div class="rightTitle">路线预览</div>
                            <div class="map">
                                <baidu-map
                                    class="map"
                                    :center="centerPosi"
                                    :zoom="17"
                                    :scroll-wheel-zoom="true"
                                >
                                    <bm-marker
                                        v-for="item in polylinePath"
                                        :key="item.lat"
                                        :position="item"
                                        :dragging="false"
                                        :icon="{
                                            url: 'https://ylsqfile-dev.zhiyanglao.cn/1yppDvxYnM70vC6sopoERDM72XY3VzPw/image',
                                            size: {
                                                width: 33,
                                                height: 80,
                                            },
                                        }"
                                    ></bm-marker>
                                    <my-overlay
                                        v-for="(item, key) in polylinePath"
                                        :key="key"
                                        :position="{lng: item.lng, lat: item.lat}"
                                        :active="active"
                                        :text="key + 1"
                                        @mouseover.native="active = true"
                                        @mouseleave.native="active = false">
                                    </my-overlay>
                                    <bm-polyline
                                        :path="polylinePath"
                                        stroke-color="blue"
                                        :stroke-opacity="0.5"
                                        :stroke-weight="2"
                                        :editing="false"
                                        @lineupdate="updatePolylinePath"
                                    >
                                    </bm-polyline>
                                </baidu-map>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot" v-if="!msgFlag">
            <div class="btn">
                <div class="commBtn closeBtn" @click="backClose()">取消</div>
                <div class="commBtn successBtn" @click="preservationData()">
                    保存
                </div>
            </div>
        </div>

        <el-dialog
            title="选择点位"
            :visible.sync="dialogVisible"
            width="561px"
            height="508px"
            :before-close="handleClose()"
        >
            <div class="dialogFrom">
                <div class="fromBox">
                    <div class="fromBoxFont">点位名</div>
                    <div class="fromBoxInp">
                        <el-input
                            v-model="searchVal"
                            placeholder="请输入"
                            prefix-icon="el-icon-search"
                        ></el-input>
                    </div>
                    <div class="searchSopt" @click="addPlace">搜索</div>
                </div>

                <div class="soptBox marginTop_30">
                    <div
                        class="menuSelect"
                        v-for="(item, key) in checketRouteArr"
                        :key="key"
                    >
                        <div class="check">
                            <el-radio v-model="routeRadio" :label="key">
                                <div class="imgSopt">
                                    <img v-if="item.picture" :src="item.picture" alt="" />
                                    <img v-if="!item.picture" src="../../../assets/placeDefaultImg.png" alt="" />
                                </div>
                                <div class="fontSopt">{{ item.name }}</div>
                            </el-radio>
                        </div>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button
                    class="successBtn"
                    type="primary"
                    @click="defineAddPlace()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import HeadView from "@/components/HeadView";

import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import { BmlMarkerClusterer } from "vue-baidu-map";
import MyOverlay from '../../../components/MyOverlay.vue'
export default {
    name: "routersAdd",
    data() {
        return {
            imgHead: "",
            fileImg: "",
            insId: "",

            routeName: "",

            dialogVisible: false,
            loading: false,
            posiObj: {
                row: "",
                jwe: "",
            },

            searchVal: "",

            checketRouteArr: [],
            routeRadio: "",

            tableData: [],
            tableDataLength: 0,

            polylinePath: [],
            centerPosi: { lng: 116.404, lat: 39.915 },
            active: false,

            editTitle: "新建路线",
            editFlag: false, //是否为编辑
            msgFlag: false,  //是否为详情
            routeId: "",
            oldTableData: [],
        };
    },

    components: {
        HeadView,
        BaiduMap,
        BmlMarkerClusterer,
        MyOverlay
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"))

        if (this.$route.query.id) {
            this.editTitle = "编辑路线";
            this.editFlag = true;
            this.routeId = this.$route.query.id;
            this.msgFlag = this.$route.query.flag
            if (this.msgFlag != undefined) {
                this.editTitle = '路线详情'
                this.msgFlag = true
            } else {
                this.msgFlag = false
            }
            this.routeEditInfo(this.$route.query.id);
        }
    },

    methods: {
        getdepInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getDeptList", data)
                .then((depRes) => {
                    if (depRes.code == 0) {
                        this.depArr = depRes.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: depRes.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取部门失败",
                    });
                });
        },
        routeEditInfo(routeId) {
            let _this = this
            let data = {
                token: this.getCookie(),
                routeId: routeId,
            };
            this.request
                .post(this.baseUrl + "route/getRouteDetail", data)
                .then(function(res) {
                    if (res.code == 0 && res.data.name) {
                        let dataArr = [];
                        res.data.placeList.sort((val1, val2) => {
                            return val1.orderNumber - val2.orderNumber;
                        });
                        _this.imgHead = res.data.picture;
                        _this.routeName = res.data.name;
                        res.data.placeList.forEach((item, key) => {
                            dataArr.push(item);
                            dataArr[key]["index"] = key + 1;
                            dataArr[key]["LongAndLati"] =
                                item.longitude + "," + item.latitude;

                            if (key == 0) {
                                _this.centerPosi = {
                                    lng: item.longitude,
                                    lat: item.latitude,
                                };
                            }
                        });
                        
                        _this.tableData = [...dataArr];
                        _this.oldTableData = [...dataArr];

                        _this.tableDataLength = _this.tableData.length;

                        _this.mapInfo();
                    } else {
                        _this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取详情失败",
                    });
                });
        },

        addPlace() {
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                keyword: this.searchVal,
            };
            const loading = this.$loading({
                lock: true,
                text: "",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.request
                .post(this.baseUrl + "place/getAllPlaceList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.dialogVisible = true;
                        let dataArr = [];
                        res.data.forEach((item, key) => {
                            dataArr.push(item);
                            dataArr[key]["flag"] = false;
                        });
                        this.checketRouteArr = dataArr;
                        this.routeRadio = "";
                    }
                    loading.close();
                });
        },

        defineAddPlace() {
            if (this.routeRadio === "") {
                return this.$message({
                    type: "error",
                    message: "请先选择您要添加的点位",
                });
            }
            const selectedPlace = this.checketRouteArr[this.routeRadio];
            const exists = this.tableData.some(item => item.placeId === selectedPlace.placeId);
            
            if (exists) {
                return this.$message({
                    type: "error",
                    message: "该点位已存在于当前路线中",
                });
            }
            this.tableData.push(this.checketRouteArr[this.routeRadio]);
            this.tableData[this.tableData.length - 1]["LongAndLati"] =
                this.tableData[this.tableData.length - 1]["longitude"] +
                "," +
                this.tableData[this.tableData.length - 1]["latitude"];
            this.tableData[this.tableData.length - 1]["index"] =
                this.tableData.length;
            this.tableDataLength = this.tableData.length;
            this.dialogVisible = false;

            this.mapInfo();
        },

        handleClose() {
            // this.dialogVisible = false
        },

        handleDelete(index, row) {
            //删除点位
            for (let x = index; x < this.tableData.length; x++) {
                this.tableData[x]["index"] = this.tableData[x]["index"] - 1;
            }
            this.tableData.splice(index, 1);
            this.tableDataLength = this.tableDataLength - 1;
            this.polylinePath = []
            this.$nextTick(() => {
                this.mapInfo();
            })
        },

        handleUpMove(index, row) {
            //上移
            let upObj = this.tableData[index - 1];
            this.tableData[index] = upObj;
            this.tableData[index]["index"] = this.tableData[index]["index"] + 1;
            this.tableData[index - 1] = row;
            this.tableData[index - 1]["index"] =
                this.tableData[index]["index"] - 1;
            let dataArr = this.tableData;
            this.tableData = [];
            this.tableData = dataArr;

            if (this.editFlag) {
                this.tableData[index]["orderNumber"] =
                    this.tableData[index]["index"];
                this.tableData[index - 1]["orderNumber"] =
                    this.tableData[index - 1]["index"];
            }
            this.mapInfo();
        },

        handleDownMove(index, row) {
            //下移
            let upObj = this.tableData[index + 1];
            this.tableData[index] = upObj;
            this.tableData[index]["index"] = this.tableData[index]["index"] - 1;
            this.tableData[index + 1] = row;
            this.tableData[index + 1]["index"] =
                this.tableData[index]["index"] + 1;
            let dataArr = this.tableData;
            this.tableData = [];
            this.tableData = dataArr;

            if (this.editFlag) {
                this.tableData[index]["orderNumber"] =
                    this.tableData[index]["index"];
                this.tableData[index + 1]["orderNumber"] =
                    this.tableData[index + 1]["index"];
            }

            this.mapInfo();
        },

        trimBoth(type, val) {
            let trimVal = val.trim();

            switch (type) {
                case "name":
                    this.routeName = trimVal;
                    break;
            }
        },

        uploadHeadImg() {
            //头像
            let _this = this;
            let file = this.$refs.headImgRef.files[0];
            this.fileImg = this.$refs.headImgRef.files[0];
            let imgData = new FileReader();
            imgData.readAsDataURL(file);
            imgData.onload = function (ev) {
                _this.imgHead = this.result;
            };
        },

        delHeadImg() {
            //清空头像
            this.imgHead = "";
            this.fileImg = "";
        },

        preservationData() {
            //保存信息
            if (!this.routeName) {
                return this.$message({
                    type: "warning",
                    message: "路线名称不能为空",
                });
            } else if (this.tableData.length <= 0) {
                return this.$message({
                    type: "warning",
                    message: "请至少添加一个点位",
                });
            }
            const loading = this.$loading({
                lock: true,
                text: "保存信息中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            if (this.imgHead && this.imgHead.indexOf("http") < 0) {
                let fromData = new FormData()
                fromData.append('file', this.fileImg)
                fromData.append('token', this.getCookie())

                this.request
                    .post(this.commUrl + "uploadFile", fromData)
                    .then((resUrl) => {
                        if (resUrl.code == 0) {
                            if (this.editFlag) {
                                this.upEditInfo(resUrl.data.url, loading);
                                return;
                            }
                            this.saveInformation(resUrl.data.url, loading);
                        } else {
                            loading.close();
                            this.$message({
                                type: "error",
                                message: resUrl.msg,
                            });
                        }
                    })
                    .catch((err) => {
                        this.$message({
                            type: "error",
                            message: err,
                        });
                    });
            } else {
                if (this.editFlag) {
                    this.upEditInfo(this.imgHead, loading);
                    return;
                }
                this.saveInformation('', loading);
            }
        },

        saveInformation(url = "", loading) {
            let placeList = [];
            this.tableData.forEach((item) => {
                placeList.push({
                    placeId: item.placeId,
                    orderNumber: item.index,
                });
            });

            let data = {
                token: this.getCookie(),
                insId: this.insId,
                name: this.routeName,
                picture: url,
                placeList: placeList,
            };
            this.request
                .post(this.baseUrl + "route/addRoute", data)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.result) {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "保存成功",
                            });
                            setTimeout(() => {
                                this.$message.closeAll();
                                this.$router.push("/routers");
                            }, 1000);
                        } else {
                            loading.close();
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        upEditInfo(url = "", loading) {
            let placeList = [];
            this.tableData.forEach((item) => {
                placeList.push({
                    routePlaceId: item.routePlaceId ? item.routePlaceId : "",
                    placeId: item.placeId,
                    orderNumber: item.index,
                    isDelete: false,
                });
            });

            const currentRoutePlaceIds = new Set(
                this.tableData
                    .filter(i => i.routePlaceId)
                    .map(i => i.routePlaceId)
            );
            this.oldTableData.forEach(old => {
                if (old.routePlaceId && !currentRoutePlaceIds.has(old.routePlaceId)) {
                    placeList.push({
                        routePlaceId: old.routePlaceId,
                        placeId: old.placeId,
                        orderNumber: old.index,
                        isDelete: true
                    });
                }
            });

            placeList.filter((item) => {
                if (item.routePlaceId == "") {
                    delete item.routePlaceId;
                }
                return item;
            });
            // console.log(placeList, this.oldTableData)
            // return
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                routeId: this.routeId,
                name: this.routeName,
                picture: url == "" ? this.imgHead : url,
                placeList: placeList,
            };
            this.request
                .post(this.baseUrl + "route/updateRoute", data)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.result) {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "修改成功",
                            });
                            setTimeout(() => {
                                this.$message.closeAll();
                                this.$router.push("/routers");
                            }, 1000);
                        } else {
                            loading.close();
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        updatePolylinePath(e) {
            this.polylinePath = e.target.getPath();
        },
        addPolylinePoint() {
            this.polylinePath.push({ lng: 116.404, lat: 39.915 });
        },

        mapInfo() {
            if (this.tableData.length <= 0) {
                this.centerPosi = { lng: 116.404, lat: 39.915 };
            }
            
            let posiArr = [];
            this.tableData.forEach((item, key) => {
                if (key == 0) {
                    this.centerPosi = {
                        lng: item.longitude,
                        lat: item.latitude,
                    };
                }
                posiArr.push({
                    lng: item.longitude,
                    lat: item.latitude,
                });
            });
            this.polylinePath = posiArr;
        },

        backClose() {
            this.$router.replace("/routers");
        },

        draw ({el, BMap, map}) {
            const pixel = map.pointToOverlayPixel(new BMap.Point(116.404, 39.915))
            el.style.left = pixel.x - 60 + 'px'
            el.style.top = pixel.y - 20 + 'px'
        },


    },
};
</script>

<style lang="less" scoped>

.rputersAdd {
    position: relative;
    height: 100vh;
    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
            cursor: pointer;
        }
        .breadcrumbChilder {
            margin-top: 24px;
            height: 20px;
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }

        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            height: 692px;
            background: #fff;
        }
    }

    .addBox {
        padding: 24px 0 0 24px;
        .instMsg {
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            font-weight: 500;
        }

        .userNum {
            line-height: 40px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
        }

        .commRowstyle {
            display: flex;
            flex-direction: row;
            .inpTitle {
                width: 107px;
                color: rgba(84, 85, 86, 1);
                font-size: 14px;
                line-height: 40px;
                font-weight: 500;
                span {
                    color: red;
                }
            }
            .inpFrom {
                width: 265px;

                input {
                    width: 100%;
                }
            }

            .posiInp {
                display: flex;
                flex-direction: row;
                width: 298px;

                .posiFont {
                    width: 47px;
                    line-height: 40px;
                    font-size: 12px;
                    text-align: center;
                }

                .posiImport {
                    width: 102px;

                    /deep/ .el-input__inner {
                        width: 100%;
                    }
                }
            }

            .codeFont {
                line-height: 40px;
                font-size: 14px;
            }
        }

        .marginTop_30 {
            margin-top: 30px;
        }

        .marginLeft_40 {
            margin-left: 40px;
            text-align: left;
        }

        .logo {
            margin-top: 12px;
            .logoSplick {
                height: 60px;
                line-height: 60px;
            }
            .borderClass {
                border: 1px solid rgba(216, 220, 230, 1);
            }
            .addHeadImg {
                position: relative;
                width: 60px;
                height: 60px;
                background: url("../../../assets/addBtn.png") no-repeat center
                    center;
                overflow: hidden;
                input {
                    opacity: 0;
                    width: 100%;
                    height: 100%;
                }
                img {
                    width: 100%;
                }
                .delHeadImg {
                    display: none;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    color: #fff;
                    text-align: center;
                    line-height: 60px;
                }
            }
            .addHeadImg:hover .delHeadImg {
                display: block;
            }
        }
    }

    .foot {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 71px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;

        .btn {
            float: right;
            display: flex;
            flex-direction: row;
            padding-top: 15.5px;
            padding-right: 56px;
            .commBtn {
                width: 95px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .successBtn {
                color: rgba(255, 255, 255, 1);
                background: rgba(103, 194, 58, 1);
            }

            .closeBtn {
                margin-right: 24px;
                color: rgba(96, 98, 102, 1);
                font-size: 14px;
                font-weight: 500;
                border: 1px solid rgba(220, 223, 230, 1);
            }
        }
    }

    .requirementBody {
        display: flex;
        flex-direction: row;
        width: 1134px;

        .requirementTop {
            width: 100%;
            height: 32px;
            clear: both;
        }

        .requirementTitle {
            float: left;
            height: 32px;
            line-height: 32px;
            font-size: 16px;
            color: rgba(84, 85, 86, 1);
            text-align: left;
        }

        .requirementAddBtn {
            float: right;
            width: 98px;
            height: 32px;
            opacity: 1;
            background-color: rgba(25, 137, 250, 1);
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 32px;
            border-radius: 4px;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            vertical-align: top;
            cursor: pointer;
        }

        .requirementTab {
            padding-top: 21px;
            width: 100%;
            height: 350px;
            overflow-y: auto;
            /deep/ .el-button--success {
                width: 56px;
                height: 28px;
                background-color: rgba(0, 186, 173, 1);
                border: none;
            }
        }

        .right {
            padding-left: 63px;
            .rightTitle {
                font-size: 16px;
                font-weight: 500;
                color: rgba(84, 85, 86, 1);
            }

            .map {
                margin-top: 25px;
                width: 513px;
                height: 357px;

                .bm-view {
                    width: 100%;
                    height: 357px;
                }
            }
        }
    }

    .routerImg {
        margin: 0 auto;
        width: 78px;
        height: 78px;
        overflow: hidden;
        img {
            width: 100%;
        }
    }

    .colorBlur {
        color: rgba(25, 137, 250, 1);
    }

    .dialogFrom {
        .fromBox {
            display: flex;
            flex-direction: row;

            .fromBoxFont {
                width: 57px;
                height: 40px;
                line-height: 40px;
                color: rgba(128, 128, 128, 1);
                span {
                    color: rgba(255, 74, 74, 1);
                }
            }

            .fromBoxInp {
                width: 211px;

                /deep/ .el-input__inner {
                    width: 100%;
                }

                p {
                    /deep/ .is-checked .el-checkbox__inner {
                        background: rgba(25, 137, 250, 1);
                    }
                }

                .fromBoxInp_p {
                    margin-top: 10px;
                }
            }

            .searchSopt {
                margin-left: 15px;
                width: 68px;
                height: 40px;
                border-radius: 4px;
                background: rgba(4, 134, 254, 1);
                text-align: center;
                line-height: 40px;
                color: #fff;
                font-size: 14px;
                cursor: pointer;
            }
        }

        .soptBox {
            width: 521px;
            height: 311px;
            overflow-y: auto;
            border: 1px solid rgba(246, 245, 245, 1);
            background: #fff;

            .menuSelect {
                display: flex;
                flex-direction: row;
                margin: 0 41px;
                height: auto;
                border-bottom: 1px solid rgba(229, 229, 229, 0.5);

                .check {
                    padding: 10px 0;
                }

                /deep/ .el-radio__input {
                    display: block;
                    float: left;
                    margin-top: 32px;
                }

                .imgSopt {
                    // display: inline-block;
                    float: left;
                    margin-left: 16px;
                    width: 78px;
                    height: 78px;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }

                .fontSopt {
                    float: left;
                    margin-left: 16px;
                    line-height: 78px;
                }
            }
        }

        .marginTop_30 {
            margin-top: 30px;
        }
    }
}

/deep/ .el-dialog {
    display: flex;
    display: -ms-flex; /* 兼容IE */
    flex-direction: column;
    -ms-flex-direction: column; /* 兼容IE */
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.el-dialog .el-dialog__body {
    max-height: 100%;
    flex: 1;
    -ms-flex: 1 1 auto; /* 兼容IE */
    overflow-y: auto;
    overflow-x: hidden;
}

.el-dialog__wrapper {
    /*隐藏ie和edge中遮罩的滚动条*/
    overflow: hidden;
}

.dialog-footer {
    /deep/ .successBtn {
        background: rgba(64, 158, 255, 1);
        border-color: rgba(64, 158, 255, 1);
    }
}

/deep/ .el-input__inner {
    width: 256px;
}

.inpColorRed {
    /deep/ .el-input__inner {
        border: 1px solid red;
    }
}
</style>